import React from "react";
import Footer from "../components/footer/en/Footer";
import Header from "../components/header/en/Header";
import AttorneyContents from "../components/pages/mypage/en/AttorneyContents";
import Contents from "../components/pages/mypage/en/Contents";
import { Storage } from "../modules/Storage";

const Mypage = () => {
  const role = Storage.get("role");
  return (
    <>
      <Header />
      {role?.includes("attorney") ? <AttorneyContents /> : <Contents />}
      <Footer />
    </>
  );
};

export default Mypage;
